import {
  // filterMode,
  // typeIcons,
  getFilterIcon
} from '../../common/filter-mode';

require('./catalog-node.component.scss');

class CatalogNodeController {
  constructor(
    $q,
    $scope,
    FilterEditorService,
    FilterCardEditorModalService,
    PermissionService,
    RouterService,
    LayoutService,
    CatalogNodeDragService,
    CurrentFilterService,
    FilterResource
  ) {
    this.$q = $q;
    this.$scope = $scope;
    this.CurrentFilterService = CurrentFilterService;
    this.FilterEditorService = FilterEditorService;
    this.FilterCardEditorModalService = FilterCardEditorModalService;
    this.permission = PermissionService;
    this.router = RouterService;
    this.drag = CatalogNodeDragService;
    this.layout = LayoutService;
    this.FilterResource = FilterResource;
    // this.filterProps = {};
  }

  get initiated() {
    return window.status === 'INIT_COMPLETE';
  }

  count(propName) {

    return this.filter ? this.filter.count(propName): 0;
  }

  hasProp(propName) {
    return this.filter.hasProp(propName);
  }

  setFilterProps() {
    for (const p in this.filterProps) this.filterProps[p].value =
      this.filterProps[p].count ? this.filter.count(p) : this.filter.hasProp(p);
  }


  get showReport() {
    if (this.layout.openedFilters.all && !this.layout.openedFilters[this.filter.id]) this.layout.openedFilters[this.filter.id] = true;
    return this.layout.openedFilters[this.filter.id];
  }

  set showReport(val) {
    if (!val) this.layout.openedFilters.all = false;
    this.layout.openedFilters[this.filter.id] = val;
  }

  get isActive() {
    return this.CurrentFilterService.filter && this.CurrentFilterService.filter.id === this.filter.id;
  }

  get isEditCatalog() {
    return this.layout.editCatalog;
  }

  get filterIcon() {
    return getFilterIcon(this.filter);
  }

  get folderIcon() {
    if (this.filter.content_type === 'folder') {
      if (this.showReport)
        return 'icon-folder-open-empty';
      else
        return 'icon-folder-empty';
    }
    if (this.showReport)
      return 'icon-folder-open-empty';
    else
      return this.filterIcon;
  }

  selectFilter() {
    if (this.filter.content_type === 'folder') this.toggleNode();
    if (this.filter.isPolitic && !this.filter.isAnalyticPolitic &&
      !this.filter.isDashboard && !this.filter.isCard && this.permission.policies) {
      this.editFilter();
      return;
    }

    this.router.selectFilter(this.filter.id);

    const resetCount = true;
    if (this.filter.facts_count && resetCount) {
      this.FilterResource.save(this.filter)
        .then(() => {
          this.filter.facts_count = 0;
        })
        .catch(error => {
          console.error(!error);
        });
    }

    this.showReport = true;
  }

  toggleNode() {
    this.showReport = !this.showReport;

  }

  needToShowFilter1(filter) {
    return false;
  }

  needToShowFilter(filter) {

    if (!this.layout.searchedFilters.all) {
      if (this.layout.searchedFilters[filter.id]) {
        this.showReport = true;
        return true;
      } else return false;
    }
    return true;
  }

  editFilter() {
    return this.FilterEditorService.editModal({
      filter: this.filter,
      asNew: false,
      selectFilter: false,
    });
  }

}

export const CatalogNodeComponent = {
  template: require('./catalog-node.component.html'),
  // require: {
  //   parentNode: '^scCatalogNode'
  // },
  // replace: true,
  bindings: {
    index: '<',
    model: '<',
    filter: '<',
    // parentFilter: '<',
    // parentScope: '<',
    // filterBar: '<',
  },
  controller: CatalogNodeController,
};



// WEBPACK FOOTER //
// ./src/filter/catalog/catalog-node.component.js